import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import React from 'react';

import { WsTypoColors, mapColor } from '../WsTypography';

export interface WsTimeLineProps {
  activityList: WsActivityProps[];
  timeLineDotVariant: 'filled' | 'outlined';
  color?: WsTypoColors;
  withoutOppositeContent?: boolean;
}
export interface WsActivityProps {
  activity: React.ReactNode;
  leftChildren: React.ReactNode;
}
const WsTimeLine = ({
  activityList,
  timeLineDotVariant,
  color,
  withoutOppositeContent = false,
}: WsTimeLineProps) => (
  <>
    {activityList?.map((child, index) => (
      <Timeline
        key={index}
        {...(withoutOppositeContent && {
          sx: {
            [`& .${timelineItemClasses.root}:before`]: {
              flex: 0,
              padding: 0,
            },
          },
        })}
      >
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color={mapColor.get(color)} variant={timeLineDotVariant}>
              {child.leftChildren}
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>{child.activity}</TimelineContent>
        </TimelineItem>
      </Timeline>
    ))}
  </>
);
export default WsTimeLine;
